import arrayTools from "_src/engine/utility/arrays";
import windowManager from "_src/client/window_manager";
import renderGraph from "_src/render_graph/render_graph";
import appState from "_src/app_state";

export default {

  requestSelectionMask(type) {

    let passType = type == appState.ST_LASSO ? renderGraph.LASSO : renderGraph.SELECTION;
    let sceneNumber = type == appState.ST_LASSO ? 1 : 0;

    const mainRenderGraph = windowManager.getWindow(windowManager.MAIN).renderGraph;
    const pass = mainRenderGraph.getPass(passType);
    const scene = pass.getScenes()[sceneNumber];

    mainRenderGraph.requestFrame();

    return pass.readPixels(sceneNumber, scene.camera.viewport).then((rgbaBuffer) => {
      //NOTE: we reduce buffer size here
      const reducedLength = rgbaBuffer.length / 4;
      const arrayBuffer = arrayTools.getArrayBuffer(reducedLength);
      const reducedBuffer = new Uint8Array(arrayBuffer);

      for (let i = 0; i < reducedLength; ++i) {
        if (rgbaBuffer[i * 4] != 0) {
          reducedBuffer[i] = 1;
        }
      }

      arrayTools.returnArrayBuffer(rgbaBuffer.buffer);

      return reducedBuffer;

    });

  },

}
